var _rect, _path, _rect2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNoDataIcon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 139,
    height: 139,
    rx: 69.5,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.025 45H80.9775C88.7 45 93 49.45 93 57.075V82.9C93 90.65 88.7 95 80.9775 95H60.025C52.425 95 48 90.65 48 82.9V57.075C48 49.45 52.425 45 60.025 45ZM60.7 56.65V56.625H68.1725C69.25 56.625 70.125 57.5 70.125 58.5725C70.125 59.675 69.25 60.55 68.1725 60.55H60.7C59.6225 60.55 58.75 59.675 58.75 58.6C58.75 57.525 59.6225 56.65 60.7 56.65ZM60.7 71.85H80.3C81.375 71.85 82.25 70.975 82.25 69.9C82.25 68.825 81.375 67.9475 80.3 67.9475H60.7C59.6225 67.9475 58.75 68.825 58.75 69.9C58.75 70.975 59.6225 71.85 60.7 71.85ZM60.7 83.275H80.3C81.2975 83.175 82.05 82.3225 82.05 81.325C82.05 80.3 81.2975 79.45 80.3 79.35H60.7C59.95 79.275 59.225 79.625 58.825 80.275C58.425 80.9 58.425 81.725 58.825 82.375C59.225 83 59.95 83.375 60.7 83.275Z",
    fill: "#0F0F0F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 139,
    height: 139,
    rx: 69.5,
    stroke: "#E7E7E7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoDataIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NoDataIcon.f4daf197.svg";
export { ForwardRef as ReactComponent };